import script from "./BoatInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./BoatInfo.vue?vue&type=script&setup=true&lang=js"

import "./BoatInfo.vue?vue&type=style&index=0&id=b82f0a66&lang=css"

const __exports__ = script;

export default __exports__